import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch'
import { LandingComponent } from '../landing/landing.component';
import { PaymentSelectionComponent } from '../eb/paymentSelection.component'
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { PassengerRequestModel, OffersRequestModel, PassengerDetails } from './travellers.model';
import { AppService } from '../../app.service';
import { HttpService } from '../../services/http.service';
import { ErrorService } from '../error/error.service';
import { BuywifiService } from '../../services/buywifi.service';
import { TravelersService } from './travelers.service';
import { UtilService } from '../../util.service';

@Injectable()
export class TravellersService {
  public passengerDetails;
  public formPassengerRequest;
  public passengerId;
  public passengerResponseReceived;
  public activateStatus;

  constructor(private appService: AppService, private httpService: HttpService, private errorService: ErrorService,
    private buywifiService: BuywifiService, private travelersService: TravelersService, private utilService: UtilService,
    private router: Router) { }

  setPassengerDetails(details): any {
    this.passengerDetails = details;
  }
  getPassengerDetails(): PassengerDetails {
    this.activateStatus = this.appService.getActivateStatus();
    if (!this.activateStatus && (!this.passengerDetails || this.passengerDetails === '')) {
      this.passengerDetails = this.travelersService.getPnrFormData();
    }
    return this.passengerDetails;
  }

  clearPassengerDetails() {
    this.passengerDetails = '';
  }

  getCharterPassengerDetails() {
    return this.travelersService.getCharterFormData();
  }

  getPassengerRequestEntity(): PassengerRequestModel {
    const deviceDetails = this.appService.getDeviceResponse();
    this.getPassengerDetails();
    const pnr = (this.passengerDetails != null && this.passengerDetails.pnr != null) ? this.passengerDetails.pnr : deviceDetails.passenger.bookingReference;
    const fN = (this.passengerDetails != null && this.passengerDetails.firstname != null) ? this.passengerDetails.firstname : deviceDetails.passenger.firstName;
    const lN = (this.passengerDetails != null && this.passengerDetails.secondname != null) ? this.passengerDetails.secondname : deviceDetails.passenger.lastName;
    const request = ONBOARD_CONSTANTS.GET_PASSENGER.replace('<<pnr>>', pnr).replace('<<fn>>', fN).replace('<<ln>>', lN);
    this.formPassengerRequest = `${request}&flightId=${deviceDetails.flightId}&expand=ReservationInfo`;
    const getPassengerRequest = {
      url: environment.apiBaseUrl + this.formPassengerRequest,
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    };
    return getPassengerRequest;
  }

  getOffersRequestEntity(reservationId, offerUrl): OffersRequestModel {
    let pos, context, requestUrl;
    if (offerUrl === '') {
      pos = this.appService.getPOS();
      context = this.appService.getContext();
      const channel = this.appService.getChannel();
      const params = `?reservationId=${reservationId}&pos=${pos}&channel=${channel}&context=${context}`;
      requestUrl = environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_OFFERS_CALL + params
    } else {
      requestUrl = environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_OFFERS + offerUrl;
    }
    const request = {
      url: requestUrl,
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    };
    return request;
  }

  doGetPassengersCall(): Observable<any> {
    const request = this.getPassengerRequestEntity();
    return this.httpService.getData(request).map(
      passengerResponse => {
        if (passengerResponse.reservationInfo) {
          this.passengerResponseReceived = passengerResponse;
          this.buywifiService.setPassengerResponse(passengerResponse);
        } else {
          if (passengerResponse.errors) {
            this.errorService.addError(passengerResponse.errors);
          } else {
            this.errorService.addError(this.buywifiService.getDefaultError());
          }
          this.appService.hideLoader();
        }
        return passengerResponse;
      },
      error => {
        return error;
      });
  }


  getCharterOffersRequest(offerUrl) {
    let pos, context, channel, requestUrl;
    if (offerUrl === '') {
      pos = this.appService.getPOS();
      context = this.appService.getContext();
      channel = this.appService.getChannel();
      const flightResponse = this.appService.getFlightResponse();
      const orgin = flightResponse.origin.iataCode;
      const destination = flightResponse.destination.iataCode;
      const params = `?origin=${orgin}&destination=${destination}&pos=${pos}&channel=${channel}&context=${context}`;
      requestUrl = environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_OFFERS_CALL + params;
    } else {
      requestUrl = environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_OFFERS + offerUrl;
    }
    const request = {
      url: requestUrl,
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    };
    return request;
  }

  buildAncillaryOffers() {
    this.doGetPassengersCall().subscribe(
      passengerResponse => {
        if (passengerResponse.reservationInfo) {
          if (passengerResponse.reservationInfo.reservationStatus) {
            this.appService.setUnconfirmedTicket(true);
            this.buildCharterAncillaryOffers();
          } else {
            this.doAncillaryOffersCall('').subscribe(getOffersResponse => {
              this.offerResponseSuccess(getOffersResponse);
            },
              error => {
                this.offerResponseError();
              });
          }
        } else {
          if (passengerResponse.errors) {
            this.errorService.addError(passengerResponse.errors);
          }
          this.appService.hideLoaderWithText();
        }
      },
      error => {
        this.appService.hideLoader();
        this.errorService.addError(this.getDefaultError());
      });
  }

  buildCharterAncillaryOffers() {
    this.doAncillaryOffersCall('').subscribe(getOffersResponse => {
      this.offerResponseSuccess(getOffersResponse);
    },
      error => {
        this.offerResponseError();
      });
  }

  offerResponseSuccess(getOffersResponse) {
    if (getOffersResponse.offerId) {
      this.updateCloseOverlay();
      this.router.navigate(['buywifi/product'], {
        queryParams: { refresh: new Date().getTime() }
      });
      LandingComponent.isbuyButtonTrigger = false;      
    }
    this.appService.hideLoaderWithText();
    this.appService.hideLoader();
  }

  offerResponseError() {
    this.errorService.addError(this.getDefaultError());
    this.appService.hideLoaderWithText();
    this.appService.hideLoader();
  }

  doAncillaryOffersCall(offerUrl): Observable<any> {
    let request;
    let listOfPosForCurrency;
    if (this.appService.isCharter || this.appService.isUnconfirmedTicket) {
      request = this.getCharterOffersRequest(offerUrl);
    } else {
      request = this.getOffersRequestEntity(this.passengerResponseReceived.reservationInfo.reservationId, offerUrl);
    }
    return this.httpService.getData(request).map(
      getOffersResponse => {
        if (getOffersResponse.message) {
          for (const error of getOffersResponse.message) {
            if (error.type === 'E') {
              if (error.code.substring(0, 1) === '7') {
                const singleError = [];
                singleError.push(error);
                this.errorService.addError(singleError);
              } else {
                this.errorService.addError(this.buywifiService.getErrorMessage(7011046));
              }
            }
            this.appService.hideLoader();
          }
        } else if (getOffersResponse.offerId) {
          this.buywifiService.setOffersResponse(getOffersResponse);          
          if (offerUrl === '') {
            this.buywifiService.setSessionValue(0);
          }
        }
        listOfPosForCurrency = ONBOARD_CONSTANTS.CURRENCY_POS.indexOf(getOffersResponse.pos) > -1;
        if (listOfPosForCurrency) {
          this.buywifiService.currencyPos = getOffersResponse.pos;
        } else {
          this.buywifiService.currencyPos = this.appService.getDefaultPOS();
        }
        this.utilService.initiateUtilLib(this.buywifiService.currencyPos.toUpperCase());
        this.buywifiService.setOffersResponse(getOffersResponse);
        return getOffersResponse;
      },
      error => {
        return error;
      });
  }

  updateCloseOverlay() {
    this.appService.addScrollBody();  
    this.appService.showLandingCustomer();
    this.appService.removeCustomerErrors();
    this.appService.scrollToTop();
    if (LandingComponent.showToggleButton) {
      LandingComponent.showActivateScreen = false;
    }
  }

  getPassengerCallRequest() {
    const passengerIdData = this.appService.getPassengerIdData();
    const passengerId = passengerIdData[0].href.split('=')[1];
    const requestPassengerCall = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_PASSENGER_PAXID.replace('<<passengerId>>', passengerId)
    };
    return requestPassengerCall;
  }

  getPassengersCall() {
    const request = this.getPassengerCallRequest();
    return this.httpService.getData(request).map(
      passengerResponse => {
        return passengerResponse;
      },
      error => {
        return error;
      });
  }

  getPassengersCallWithEB(basicProfileString) {
    const request = this.getPassengerCallWithEBRequest(basicProfileString);
    return this.httpService.getData(request).map(
      passengerResponse => {
        return passengerResponse;
      },
      error => {
        return error;
      });
  }

  getPassengerCallWithEBRequest(basicProfileString): any | undefined {
    const basicProfile = JSON.parse(basicProfileString);
    if (basicProfile.eb === true) {
      const firstName = basicProfile.firstName;
      const lastName = basicProfile.lastName;
      const ebNumber = basicProfile.ebNumber;
      const requestForPassengersCall = {
        url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_PASSENGER_EB.replace('<<fn>>', firstName)
          .replace('<<ln>>', lastName).replace('<<eb>>', ebNumber)
      };
      return requestForPassengersCall;
    } else {
      return undefined;
    }
  }

  getDefaultError(): any[] {    
    return [{ 'errorCode': ONBOARD_CONSTANTS.DEFAULT_ERROR }];
  }

  getPointsOffer() {
    this.doGetPassengersCall().subscribe(
      passengerResponse => {
        if (passengerResponse.id) {
          this.doPointsOffersCall(passengerResponse.id).subscribe(getPointsOfferResponse => {
            this.offerPointsResponseSuccess(getPointsOfferResponse);
          },
            error => {
              this.offerPointsResponseError();
            });
        } else {
          if (passengerResponse.errors) {
            this.errorService.addError(passengerResponse.errors);
          }
          this.appService.hideLoaderWithText();
        }
      },
      error => {
        this.appService.hideLoader();
        this.errorService.addError(this.getDefaultError());
      });
  }

  getPointsOfferWithPaxId(paxId) {
    this.doPointsOffersCall(paxId).subscribe(getPointsOfferResponse => {
      this.offerPointsResponseSuccess(getPointsOfferResponse);
    },
      error => {
        this.offerPointsResponseError();
      });
  }

  doPointsOffersCall(passengerId) {
    let request;
    request = this.getPointsOfferRequestEntity(passengerId);
    return this.httpService.getData(request).map(
      getPointsOfferResponse => {
        if (getPointsOfferResponse.errors) {
          this.errorService.addError(getPointsOfferResponse.errors);
        } else if (getPointsOfferResponse.offerId) {
          this.buywifiService.setPointsOfferResponse(getPointsOfferResponse);
        }
        return getPointsOfferResponse;
      },
      error => {
        return error;
      });
  }

  getPointsOfferRequestEntity(passengerId) {
    const request = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_POINTS.replace('<<passengerId>>', passengerId)
    };
    return request;
  }

  offerPointsResponseSuccess(getOffersResponse) {
    if (getOffersResponse.offerId) {
      this.router.navigate(['buywifi/product']);
      LandingComponent.isbuyButtonTrigger = false;
      this.errorService.removeError();
    }
    this.appService.hideLoaderWithText();
    this.appService.hideLoader();
  }

  offerPointsResponseError() {
    this.errorService.addError(this.getDefaultError());
    this.appService.hideLoaderWithText();
    this.appService.hideLoader();
  }

  redirectCardFlowFromEBAfterError() {
    PaymentSelectionComponent.showEBforPointsBuy = false;
    const loaderTextList = { loaderHeaderText: 'loaderText' };    
    if(this.appService.isCharter) {
      const charterFormData = this.travelersService.getCharterFormData();
      this.setPassengerDetails(charterFormData);
      this.appService.showLoaderWithText(loaderTextList);
      this.buildCharterAncillaryOffers();
    }
    else {
      const pnrFormData = this.travelersService.getPnrFormData();
      this.setPassengerDetails(pnrFormData);
      this.appService.showLoaderWithText(loaderTextList);
      this.buildAncillaryOffers();
    }        
  }
}
